import React from "react";
import GOIRulesSection from "./GOIRulesSection";
import GOIDetailsSection from "./GOIDetailsSection";

const tabComponents = {
  details: GOIDetailsSection,
  rules: GOIRulesSection,
};

// Renders the content of the active tab
// active Tab: can have three different values, details, rules, and empty
// data: object containing the data of the generated object
const GOIRenderTabContent = ({ activeTab, data }) => {
  const Component = tabComponents[activeTab];

  return Component ? <Component data={data} /> : null;
};

export default GOIRenderTabContent;
